import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.78 28.62c-1.92-1.42-.46-4.24.06-5.08-.94 1.04-1.88 2.06-2.6 3.18-1.14 1.76-1.64 3.7-.86 4.94 1.4 2.24 4.74 1.2 6.86.3L42 23.62l-19.52 5.16c-1.64.42-2.96.38-3.7-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M46.5 9v24c0 2.48-2.02 4.5-4.5 4.5H6c-2.48 0-4.5-2.02-4.5-4.5v-3.86l17.52-10.12c.34-.2.66-.44.94-.72l7.8-7.8h8.26c2.48 0 4.5 2.02 4.5 4.5v3"
  }))
};
export var ShopSNKRS = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});